export const FAN_DIGIT_COUNT = 16;

export const normalizeFanId = (value) =>
  String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, FAN_DIGIT_COUNT);

export const formatFanId = (value) =>
  normalizeFanId(value).replace(/(.{4})/g, "$1 ").trim();

export const isValidFanId = (value) =>
  normalizeFanId(value).length === FAN_DIGIT_COUNT;
